module.exports = __webpack_public_path__ + "img/tuto_internet_way_01_01.a3b39a17.png";